import React from 'react';

const LoadingScreen = () => {
  return (
    <div className="main-body dark-theme-1">

      {/* Top shimmer bar (soft + blur) */}
      <div className="fixed top-0 left-0 z-50 w-full h-2 bg-gray-800/60 backdrop-blur-sm overflow-hidden">
        <div className="h-full w-1/3 bg-gradient-to-r from-[#AF0056] via-pink-500 to-[#FF4D9D] animate-[smoothSlide_1.4s_linear_infinite] blur-[1px]" />
      </div>

      <div className="main-header-s1">
        <h1 className="app-title">TLK</h1>
      </div>

      <div className="body-content">
        <div className="flex justify-center items-center py-20 flex-auto">

          {/* Smooth Loader */}
          <div className="relative flex items-center justify-center">

            {/* Outer glow ring */}
            <div className="absolute w-16 h-16 rounded-full bg-[#AF0056]/20 blur-xl animate-pulse"></div>

            {/* Spinner */}
            <div className="w-10 h-10 rounded-full border-4 border-transparent border-t-[#AF0056] border-r-pink-400 animate-spin"></div>

          </div>

        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;